<template>
  <BaseDialog
    :title="isEdit ? 'Редактировать' : 'Добавить'"
    :dialog="dialog"
    :is-show-mode="isShowMode"
    :is-edit="isEdit"
    :is-invalid="$v.$invalid"
    :save-btn-loading="saveBtnLoading"
    @close="closeModal"
    @save="save"
  >
    <UITextField
      v-model="eventTypePart.name"
      label="Название" placeholder="Добавьте название" class="mt-2"
      :disabled="isShowMode"
      :error-messages="errorMessages.name"
      @input="$v.eventTypePart.name.$touch()"
    />
  </BaseDialog>
</template>

<script>
import { EventTypePart } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import {
  maxLength,
  required,
} from 'vuelidate/lib/validators'
import UITextField from '@/ui/input/UITextField'
import BaseDialog from '@/ui/dialog/BaseDialog'

export default {
  components: {
    UITextField,
    BaseDialog,
  },

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: {
      type: Object,
      default: null,
    },
  },

  data: () => ({ eventTypePart: new EventTypePart() }),

  validations() {
    return { eventTypePart: { name: { required, maxLength: maxLength(200) } } }
  },

  computed: {
    isEdit() {
      return !!this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.eventTypePart.$params).forEach((key) => {
        allErrors[key] = setValidateMessages(this.$v.eventTypePart[key])
      })

      return allErrors
    },
  },

  methods: {
    save() {
      this.$emit('save', this.eventTypePart)
    },

    resetModal() {
      this.$v.$reset()
      this.eventTypePart = new EventTypePart()
    },

    closeModal() {
      this.eventTypePart = new EventTypePart()
      this.$emit('closeModal')
    },
  },

  watch: {
    selectedItem(val) {
      this.eventTypePart = new EventTypePart(val)
    },

    dialog(val) {
      !val && this.resetModal()
    },
  },
}
</script>
